/* ============================================================================
   HEADLIGHT COVERS — theme behaviour (ported from the Autokorrektur v2 template)
   Vanilla JS, no dependencies. Every module is independent and does nothing if
   its markup is missing.
   Modules: Toast · Header · Dock · Drawer · Ticker · Search · Rails · Stage ·
            YouTube facade · Reveals · Parallax · Vehicle memory · Finder
   ========================================================================= */
(function () {
  "use strict";
  var I18N = (window.HLC && window.HLC.i18n) || {};
  function T(k, d) { return I18N[k] || d; }

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var ROOT = (window.HLC && window.HLC.rootUrl) || "/";
  if (ROOT.length > 1 && ROOT.slice(-1) === "/") ROOT = ROOT.slice(0, -1);
  if (ROOT === "/") ROOT = "";

  /* ---------- Toast ------------------------------------------------------ */
  var toastEl = $("[data-toast]");
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    window.clearTimeout(toastTimer);
    toastEl.textContent = message;
    toastEl.classList.add("is-on");
    toastTimer = window.setTimeout(function () { toastEl.classList.remove("is-on"); }, 5200);
  }
  window.hlcToast = toast;

  $$("[data-year]").forEach(function (el) { el.textContent = String(new Date().getFullYear()); });

  /* ---------- Header: scrolled state ------------------------------------ */
  var header = $("[data-header]");
  if (header) {
    var lastStuck = null;
    var onScroll = function () {
      var stuck = window.scrollY > 18;
      if (stuck !== lastStuck) { header.classList.toggle("is-stuck", stuck); lastStuck = stuck; }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Dock: out of the way while scrolling on mobile ----------- */
  (function dock() {
    var el = $(".ak-dock");
    if (!el || !window.matchMedia("(max-width: 699px)").matches) return;
    var lastY = window.scrollY, idle;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (y > lastY + 6 && y > 260) el.classList.add("is-away");
      else if (y < lastY - 6) el.classList.remove("is-away");
      lastY = y;
      window.clearTimeout(idle);
      idle = window.setTimeout(function () { el.classList.remove("is-away"); }, 700);
    }, { passive: true });
  })();

  /* ---------- Mobile drawer -------------------------------------------- */
  var burger = $("[data-burger]");
  var drawer = $("[data-drawer]");
  if (burger && drawer) {
    var outside = ["main", ".ak-topbar", ".ak-footer", ".ak-dock"].map(function (s) { return $(s); }).filter(Boolean);
    var setDrawer = function (open) {
      burger.setAttribute("aria-expanded", String(open));
      drawer.classList.toggle("is-open", open);
      drawer.toggleAttribute("inert", !open);
      outside.forEach(function (el) { el.toggleAttribute("inert", open); });
      document.body.classList.toggle("ak-locked", open);
      if (open) {
        $$(".ak-drawer__links a", drawer).forEach(function (a, i) { a.style.animationDelay = (60 + i * 45) + "ms"; });
        window.setTimeout(function () { var first = $("a", drawer); if (first) first.focus(); }, 220);
      }
    };
    drawer.toggleAttribute("inert", true);
    burger.addEventListener("click", function () { setDrawer(burger.getAttribute("aria-expanded") !== "true"); });
    $$("[data-drawer-close]", drawer).forEach(function (el) { el.addEventListener("click", function () { setDrawer(false); }); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && burger.getAttribute("aria-expanded") === "true") { setDrawer(false); burger.focus(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Tab" || burger.getAttribute("aria-expanded") !== "true") return;
      var items = [burger].concat($$("a[href], button:not([disabled])", drawer));
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (items.indexOf(document.activeElement) === -1) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Ticker pause ---------------------------------------------- */
  (function ticker() {
    var root = $("[data-ticker]");
    var btn = root && $("[data-ticker-pause]", root);
    if (!root || !btn) return;
    var label = $("[data-ticker-label]", btn);
    if (reduceMotion) {
      root.classList.add("is-paused"); btn.setAttribute("aria-pressed", "true");
      if (label) label.textContent = T("static", "Static"); btn.disabled = true; return;
    }
    btn.addEventListener("click", function () {
      var paused = root.classList.toggle("is-paused");
      btn.setAttribute("aria-pressed", String(paused));
      if (label) label.textContent = paused ? "Play" : "Pause";
    });
  })();

  /* ---------- Search dialog -------------------------------------------- */
  var searchDialog = $("[data-search-dialog]");
  if (searchDialog) {
    var searchInput = $("input[type='search']", searchDialog);
    $$("[data-search-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (drawer && drawer.classList.contains("is-open") && burger) burger.click();
        if (typeof searchDialog.showModal === "function") {
          searchDialog.showModal();
          window.setTimeout(function () { if (searchInput) searchInput.focus(); }, 110);
        } else {
          window.location.href = ROOT + "/search";
        }
      });
    });
    $$("[data-search-close]", searchDialog).forEach(function (btn) { btn.addEventListener("click", function () { searchDialog.close(); }); });
    var searchForm = $("form", searchDialog);
    if (searchForm) {
      searchForm.addEventListener("submit", function (e) {
        var q = searchInput ? searchInput.value.trim() : "";
        if (!q) { e.preventDefault(); toast(T("search_term_first", "Please enter a search term first.")); if (searchInput) searchInput.focus(); }
      });
    }
  }

  /* ---------- Horizontal rails ----------------------------------------- */
  $$("[data-rail]").forEach(function (rail) {
    var id = rail.getAttribute("data-rail");
    var nav = $("[data-rail-nav='" + id + "']");
    var prev = nav ? $("[data-rail-prev]", nav) : null;
    var next = nav ? $("[data-rail-next]", nav) : null;
    rail.tabIndex = 0;
    if (!rail.getAttribute("role")) rail.setAttribute("role", "group");
    rail.setAttribute("aria-roledescription", "carousel");
    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var cs = window.getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      if (!prev || !next) return;
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= max - 4;
    }
    function move(dir) { rail.scrollBy({ left: step() * dir, behavior: reduceMotion ? "auto" : "smooth" }); }
    if (prev) prev.addEventListener("click", function () { move(-1); });
    if (next) next.addEventListener("click", function () { move(1); });
    rail.addEventListener("scroll", sync, { passive: true });
    rail.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); move(1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); move(-1); }
      else if (e.key === "Home") { e.preventDefault(); rail.scrollTo({ left: 0, behavior: reduceMotion ? "auto" : "smooth" }); }
      else if (e.key === "End") { e.preventDefault(); rail.scrollTo({ left: rail.scrollWidth, behavior: reduceMotion ? "auto" : "smooth" }); }
    });
    var down = false, startX = 0, startLeft = 0, moved = 0;
    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      down = true; moved = 0; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    rail.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) { moved = Math.abs(dx); rail.classList.add("is-dragging"); rail.scrollLeft = startLeft - dx; }
    });
    ["pointerup", "pointercancel", "pointerleave"].forEach(function (evt) {
      rail.addEventListener(evt, function () {
        if (!down) return;
        down = false;
        window.setTimeout(function () { rail.classList.remove("is-dragging"); }, 30);
        if (moved > 5) sync();
      });
    });
    if ("ResizeObserver" in window) new ResizeObserver(sync).observe(rail);
    window.setTimeout(sync, 120);
  });

  /* ---------- Stage (product worlds) ----------------------------------- */
  (function stage() {
    var root = $("[data-stage]");
    if (!root) return;
    var slides = $$("[data-slide]", root);
    if (!slides.length) return;
    var prev = $("[data-stage-prev]", root), next = $("[data-stage-next]", root);
    var current = $("[data-stage-current]", root), total = $("[data-stage-total]", root);
    var bar = $("[data-stage-bar]", root), playBtn = $("[data-stage-play]", root), live = $("[data-stage-live]", root);
    var index = 0, timer = null, playing = !reduceMotion, DELAY = 7000;
    if (total) total.textContent = String(slides.length).padStart(2, "0");
    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle("is-active", on);
        s.setAttribute("aria-hidden", String(!on));
        s.toggleAttribute("inert", !on);
      });
      if (current) current.textContent = String(index + 1).padStart(2, "0");
      if (bar) bar.style.width = ((index + 1) / slides.length * 100) + "%";
      if (live) live.textContent = T("product_world", "Product world") + " " + (index + 1) + " " + T("of", "of") + " " + slides.length;
    }
    function stop() { window.clearInterval(timer); timer = null; }
    function start() { stop(); if (!playing || reduceMotion) return; timer = window.setInterval(function () { show(index + 1); }, DELAY); }
    function setPlaying(on) {
      playing = on;
      if (playBtn) {
        playBtn.setAttribute("aria-pressed", String(!on));
        var label = $("[data-stage-play-label]", playBtn);
        if (label) label.textContent = on ? "Pause" : "Play";
      }
      if (on) start(); else stop();
    }
    function nudge() { if (playing) start(); }
    if (prev) prev.addEventListener("click", function () { show(index - 1); nudge(); });
    if (next) next.addEventListener("click", function () { show(index + 1); nudge(); });
    if (playBtn) playBtn.addEventListener("click", function () { setPlaying(!playing); });
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", function () { if (playing) start(); });
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", function () { if (playing) start(); });
    root.tabIndex = 0;
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); show(index + 1); nudge(); }
      if (e.key === "ArrowLeft") { e.preventDefault(); show(index - 1); nudge(); }
    });
    var tx = null, ty = null;
    root.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      tx = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
      show(index + (dx < 0 ? 1 : -1)); nudge();
    }, { passive: true });
    show(0);
    setPlaying(!reduceMotion);
    if (reduceMotion && playBtn) playBtn.disabled = true;
  })();

  /* ---------- YouTube facade ------------------------------------------- */
  $$("[data-yt]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-yt");
      if (!id) return;
      var frame = document.createElement("iframe");
      frame.src = "https://www.youtube-nocookie.com/embed/" + id + "?autoplay=1&rel=0&modestbranding=1" + (btn.dataset.ytStart ? "&start=" + btn.dataset.ytStart : "");
      frame.title = btn.getAttribute("data-yt-title") || T("youtube_video", "YouTube video");
      frame.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share";
      frame.referrerPolicy = "strict-origin-when-cross-origin";
      frame.allowFullscreen = true;
      var box = document.createElement("div");
      box.className = btn.className + " is-playing";
      box.appendChild(frame);
      btn.replaceWith(box);
      frame.focus();
    });
  });

  /* ---------- Reveals --------------------------------------------------- */
  var revealEls = $$(".ak-reveal, .ak-wipe, .ak-fadein");
  if (reduceMotion || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  } else {
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var group = el.closest("[data-stagger]");
        if (group && !group.dataset.staggered) {
          group.dataset.staggered = "1";
          $$(".ak-reveal, .ak-wipe, .ak-fadein", group).forEach(function (child, i) {
            child.style.setProperty("--ak-d", (i * 85) + "ms"); child.classList.add("is-in"); obs.unobserve(child);
          });
        }
        el.classList.add("is-in");
        obs.unobserve(el);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax (desktop only) ---------------------------------- */
  if (!reduceMotion && window.matchMedia("(min-width: 1000px) and (hover: hover)").matches) {
    var layers = $$("[data-parallax]");
    if (layers.length) {
      var ticking = false;
      var apply = function () {
        var vh = window.innerHeight;
        layers.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          var strength = parseFloat(el.getAttribute("data-parallax")) || 1;
          el.style.transform = "translate3d(0," + (progress * -26 * strength).toFixed(2) + "px,0)";
        });
        ticking = false;
      };
      window.addEventListener("scroll", function () { if (ticking) return; ticking = true; window.requestAnimationFrame(apply); }, { passive: true });
      apply();
    }
  }

  /* ---------- Vehicle memory (localStorage) ---------------------------- */
  var VEHICLE_KEY = "hlc.vehicle";
  function getVehicle() {
    try { var v = JSON.parse(window.localStorage.getItem(VEHICLE_KEY) || "null"); return v && v.label ? v : null; } catch (e) { return null; }
  }
  function setVehicle(v) {
    try { if (v) window.localStorage.setItem(VEHICLE_KEY, JSON.stringify(v)); else window.localStorage.removeItem(VEHICLE_KEY); } catch (e) { /* storage blocked */ }
    renderVehicleChip();
    renderFitmentBadges();
    document.dispatchEvent(new CustomEvent("hlc:vehicle", { detail: v }));
  }
  window.hlcVehicle = { get: getVehicle, set: setVehicle };

  function renderVehicleChip() {
    var v = getVehicle();
    $$("[data-vehicle-chip]").forEach(function (chip) {
      if (!v) { chip.classList.remove("is-set"); chip.removeAttribute("href"); return; }
      chip.classList.add("is-set");
      chip.innerHTML = "<b></b> <span></span>";
      chip.firstChild.textContent = T("my_car", "My car");
      chip.lastChild.textContent = v.label;
      chip.setAttribute("href", v.url || (ROOT + "/pages/find-your-car"));
      chip.setAttribute("title", T("parts_for_your", "Parts for your") + " " + v.label);
    });
    /* remove buttons / rows (header, drawer, fitment badge) only while a vehicle is remembered */
    $$("[data-vehicle-clear], [data-vehicle-row]").forEach(function (el) { el.hidden = !v; });
  }

  /* fitment badge on product pages: compares stored vehicle with data-hlc-generations */
  function renderFitmentBadges() {
    var v = getVehicle();
    $$("[data-fitment]").forEach(function (box) {
      var gens = (box.getAttribute("data-fitment-generations") || "").split(",").filter(Boolean);
      var universal = box.getAttribute("data-fitment-universal") === "true";
      var state, title, text;
      if (!v) {
        state = "unknown";
        title = T("not_sure_fits", "Not sure if it fits?");
        text = T("pick_car_hint", "Pick your car in the finder – the shop then shows what fits, what is made to order and what we can build on request.");
      } else if (universal) {
        state = "made"; title = T("made_to_order_for_your", "Made to order for your") + " " + v.label; text = "This product is made to measure for any vehicle. Your car is added to the order automatically.";
      } else if (v.handle && gens.indexOf(v.handle) > -1) {
        state = "fits"; title = T("fits_your", "Fits your") + " " + v.label; text = T("fits_text", "Vehicle-specific fit for the generation you selected.");
      } else {
        state = "no"; title = T("not_for_your", "Not for your") + " " + v.label; text = T("not_text", "This product is made for other generations. See the fitment list – or ask us for a custom build.");
      }
      box.setAttribute("data-state", state);
      var icon = { fits: "✓", made: "≈", no: "✕", unknown: "?" }[state];
      var iconEl = $("[data-fit-icon]", box), titleEl = $("[data-fit-title]", box), textEl = $("[data-fit-text]", box), link = $("[data-fit-link]", box);
      if (iconEl) iconEl.textContent = icon;
      if (titleEl) titleEl.textContent = title;
      if (textEl) textEl.textContent = text;
      if (link) {                                              // "Select vehicle" becomes "Change vehicle"
        if (!link.getAttribute("data-fit-link-default")) link.setAttribute("data-fit-link-default", link.textContent);
        link.textContent = v ? T("change_vehicle", "Change vehicle") : link.getAttribute("data-fit-link-default");
      }
    });
  }
  renderVehicleChip();
  renderFitmentBadges();
  $$("[data-vehicle-clear]").forEach(function (btn) { btn.addEventListener("click", function () { setVehicle(null); toast(T("vehicle_removed", "Vehicle removed.")); }); });

  /* ---------- Vehicle finder ------------------------------------------- */
  (function finder() {
    var forms = $$("[data-finder]");
    if (!forms.length) return;
    var DATA_URL = window.HLC && window.HLC.vehiclesUrl;
    var data = null, loading = null;
    function load() {
      if (data) return Promise.resolve(data);
      if (loading) return loading;
      loading = fetch(DATA_URL, { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (d) { data = d; return d; });
      return loading;
    }
    function norm(s) { return String(s || "").trim().toLowerCase(); }
    var thisYear = new Date().getFullYear();

    forms.forEach(function (form) {
      var panel = form.closest("[data-finder-panel]") || form.parentElement;
      var state = { make: null, model: null, gen: null, year: "" };
      var fields = $$("[data-field]", form).map(function (wrap) {
        return { key: wrap.getAttribute("data-field"), wrap: wrap, input: $("input", wrap), list: $("[data-listbox]", wrap),
                 toggle: $("[data-field-toggle]", wrap), hint: $("[data-hint]", wrap), status: $("[data-field-status]", wrap), activeIndex: -1 };
      });
      var byKey = {};
      fields.forEach(function (f) { byKey[f.key] = f; if (f.hint) f.hint.dataset.default = f.hint.textContent.trim(); });
      var ORDER = ["make", "model", "gen", "year"].filter(function (k) { return !!byKey[k]; });
      var countEl = $("[data-finder-count]", panel);

      function optionsFor(key) {
        if (!data) return [];
        if (key === "make") return data.makes.map(function (m) { return { value: m.name, note: (m.count ? m.count + " parts" : ""), ref: m }; });
        if (key === "model") {
          if (!state.make) return [];
          return state.make.models.map(function (m) {
            var fam = {};
            (m.generations || []).forEach(function (g) { (g.families || []).forEach(function (f) { fam[f] = 1; }); });
            var tags = Object.keys(fam).map(function (f) { return (data.families[f] || {}).short || f; });
            return { value: m.name, note: tags.join(" · "), ref: m };
          });
        }
        if (key === "gen") {
          if (!state.model) return [];
          return (state.model.generations || []).map(function (g) {
            var yrs = g.from ? (g.from + "–" + (g.to || "")) : "";
            return { value: g.name, note: yrs, ref: g };
          });
        }
        if (key === "year") {
          var years = [];
          for (var y = thisYear + 1; y >= 1980; y--) years.push({ value: String(y) });
          return years;
        }
        return [];
      }
      function filterOptions(key, query) {
        var all = optionsFor(key), q = norm(query);
        if (!q) return all.slice(0, 160);
        var starts = [], contains = [];
        all.forEach(function (o) {
          var v = norm(o.value + " " + ((o.ref && o.ref.aliases) ? o.ref.aliases.join(" ") : ""));
          if (norm(o.value).indexOf(q) === 0) starts.push(o); else if (v.indexOf(q) > -1) contains.push(o);
        });
        return starts.concat(contains).slice(0, 160);
      }
      function closeList(f) {
        f.wrap.classList.remove("is-open"); f.input.setAttribute("aria-expanded", "false");
        f.input.removeAttribute("aria-activedescendant"); f.activeIndex = -1;
      }
      function renderList(f, query) {
        var items = filterOptions(f.key, query);
        f.list.innerHTML = "";
        if (!items.length) {
          var li = document.createElement("li");
          li.className = "ak-listbox__empty"; li.setAttribute("role", "presentation");
          li.textContent = f.key === "model" && !state.make ? T("pick_make_first", "Pick a make first.") :
                           f.key === "gen" && !state.model ? T("pick_model_first", "Pick a model first.") :
                           f.key === "gen" ? T("no_generation_build", "No generation listed – we build to order, just tell us your car.") : T("no_suggestion_free", "No suggestion – free input is allowed.");
          f.list.appendChild(li); f.activeIndex = -1; return items;
        }
        items.forEach(function (o, i) {
          var li = document.createElement("li");
          li.id = "hlc-opt-" + f.key + "-" + i; li.setAttribute("role", "option"); li.setAttribute("aria-selected", "false");
          li.dataset.index = String(i);
          li.innerHTML = "<span></span>" + (o.note ? "<small></small>" : "");
          li.firstChild.textContent = o.value; if (o.note) li.lastChild.textContent = o.note;
          li.addEventListener("mousedown", function (e) { e.preventDefault(); choose(f, o); });
          f.list.appendChild(li);
        });
        f.activeIndex = -1; f._items = items;
        return items;
      }
      function openList(f, query) {
        load().then(function () {
          var items = renderList(f, typeof query === "string" ? query : f.input.value);
          f.wrap.classList.add("is-open"); f.input.setAttribute("aria-expanded", "true");
          if (f.status) f.status.textContent = items.length ? items.length + " " + (items.length === 1 ? T("suggestion_one", "suggestion") : T("suggestion_other", "suggestions")) : T("no_suggestion_free2", "No suggestion, free input allowed");
        });
      }
      function highlight(f, index) {
        var opts = $$("li[role='option']", f.list);
        if (!opts.length) return;
        if (index < 0) index = opts.length - 1; if (index >= opts.length) index = 0;
        opts.forEach(function (li) { li.setAttribute("aria-selected", "false"); });
        var el = opts[index]; el.setAttribute("aria-selected", "true");
        f.input.setAttribute("aria-activedescendant", el.id); f.activeIndex = index;
        var top = el.offsetTop, bottom = top + el.offsetHeight;
        if (top < f.list.scrollTop) f.list.scrollTop = top; else if (bottom > f.list.scrollTop + f.list.clientHeight) f.list.scrollTop = bottom - f.list.clientHeight;
      }
      function setHint(f, text, isError) {
        if (!f.hint) return;
        f.hint.textContent = text || f.hint.dataset.default || "";
        if (isError) { f.hint.setAttribute("data-error", ""); f.hint.setAttribute("role", "alert"); }
        else { f.hint.removeAttribute("data-error"); f.hint.removeAttribute("role"); }
      }
      function resetBelow(key) {
        var from = ORDER.indexOf(key) + 1;
        for (var i = from; i < ORDER.length; i++) {
          var f = byKey[ORDER[i]]; if (!f) continue;
          state[ORDER[i]] = ORDER[i] === "year" ? "" : null;
          f.input.value = ""; f.wrap.classList.remove("is-filled"); f.input.removeAttribute("aria-invalid"); setHint(f, "");
        }
      }
      function commit(f, o) {
        var ref = o && o.ref;
        if (f.key === "make") state.make = ref || (o && o.value ? { name: o.value, models: [], free: true } : null);
        if (f.key === "model") state.model = ref || (o && o.value ? { name: o.value, generations: [], free: true } : null);
        if (f.key === "gen") state.gen = ref || null;
        if (f.key === "year") state.year = o ? o.value : "";
        f.wrap.classList.toggle("is-filled", !!(o && o.value));
        f.input.removeAttribute("aria-invalid");
      }
      function choose(f, o) {
        f.input.value = o.value;
        resetBelow(f.key);
        commit(f, o);
        closeList(f);
        var nextKey = ORDER[ORDER.indexOf(f.key) + 1];
        var next = nextKey && byKey[nextKey];
        if (f.key === "make" && next) { var m = optionsFor("model"); setHint(next, m.length ? m.length + " " + T("models", "models") : T("free_input", "Free input allowed")); next.input.focus(); }
        if (f.key === "model" && next) {
          var g = optionsFor("gen");
          if (g.length === 1) { next.input.value = g[0].value; commit(next, g[0]); setHint(next, T("one_generation_selected", "Only one generation – selected")); }
          else { setHint(next, g.length ? g.length + " " + T("generations", "generations") : T("no_generation_optional", "No generation listed – optional")); next.input.focus(); }
        }
      }
      fields.forEach(function (f) {
        if (!f.input || !f.list) return;
        f.input.setAttribute("role", "combobox"); f.input.setAttribute("aria-expanded", "false");
        f.input.setAttribute("aria-autocomplete", "list"); f.input.setAttribute("autocomplete", "off");
        f.input.addEventListener("focus", function () { f.wrap.classList.add("is-active"); openList(f); });
        f.input.addEventListener("blur", function () {
          f.wrap.classList.remove("is-active");
          window.setTimeout(function () { closeList(f); }, 120);
          /* free text: keep the typed value as a free entry */
          var typed = f.input.value.trim();
          var exact = (f._items || []).filter(function (o) { return norm(o.value) === norm(typed); })[0];
          if (exact) commit(f, exact); else if (typed && f.key !== "gen") commit(f, { value: typed });
        });
        f.input.addEventListener("input", function () { resetBelow(f.key); openList(f); setHint(f, ""); });
        f.input.addEventListener("keydown", function (e) {
          var open = f.wrap.classList.contains("is-open");
          if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); if (!open) { openList(f); highlight(f, 0); return; } highlight(f, f.activeIndex + (e.key === "ArrowDown" ? 1 : -1)); }
          else if (e.key === "Enter") { if (open && f.activeIndex > -1) { e.preventDefault(); var o = (f._items || [])[f.activeIndex]; if (o) choose(f, o); } }
          else if (e.key === "Escape") { if (open) { e.stopPropagation(); closeList(f); } }
          else if (e.key === "Tab") { closeList(f); }
        });
        if (f.toggle) f.toggle.addEventListener("click", function () { if (f.wrap.classList.contains("is-open")) closeList(f); else { f.input.focus(); openList(f, ""); } });
      });
      document.addEventListener("click", function (e) {
        fields.forEach(function (f) { if (!f.wrap || f.wrap.contains(e.target) || f.input === document.activeElement) return; closeList(f); });
      });
      load().then(function (d) { if (countEl) countEl.textContent = d.makes.length + " " + T("makes_in_list", "makes in the list"); });

      /* ----- submit: resolve generation (by year if needed) and show results ----- */
      var result = $("[data-finder-result]", panel), body = $("[data-finder-body]", panel);
      var resultTitle = $("[data-finder-title]", panel), resultSpecs = $("[data-finder-specs]", panel);
      var resultProducts = $("[data-finder-products]", panel), live = $("[data-finder-live]", panel);

      function pickByYear(model, year) {
        var y = parseInt(year, 10);
        if (!y || !model || !model.generations) return null;
        var hits = model.generations.filter(function (g) { return g.from && y >= g.from && (!g.to || y <= g.to); });
        return hits.length === 1 ? hits[0] : null;
      }
      function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

      function madeToOrderHtml(label) {
        var html = '<div class="ak-find-group"><h3>' + T("made_to_order_for_your", "Made to order for your") + ' ' + esc(label) + '</h3><div class="ak-find-grid">';
        (data.universal || []).forEach(function (u) {
          html += '<a class="ak-find-card ak-find-card--mat" href="' + esc(u.url) + '"><span class="ak-find-card__media">' +
            (u.image ? '<img src="' + esc(u.image) + '" alt="" loading="lazy">' : "") +
            '<span class="ak-find-card__tag" data-tone="mat">' + T("any_car", "Any car") + '</span></span><span class="ak-find-card__body"><strong>' + esc(u.label) + '</strong>' +
            (u.from ? '<span class="ak-find-card__price">' + T("from", "from") + ' ' + esc(u.from) + ' <em>' + T("incl_vat", "incl. VAT") + '</em></span>' : "") +
            '<span class="ak-find-card__go">' + T("configure", "Configure") + ' <i aria-hidden="true"></i></span></span></a>';
        });
        html += "</div></div>";
        return html;
      }
      function requestHtml(label) {
        var url = ROOT + "/pages/request?vehicle=" + encodeURIComponent(label);
        return '<p class="ak-find-note">' + T("request_note", "Headlight covers and clubsport sets are not in the catalogue for this exact model yet – we build most models as one-offs on request.") + ' <a href="' + esc(url) + '">' + T("send_a_request", "Send a request") + ' ↗</a></p>';
      }

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        fields.forEach(function (f) { f.input.removeAttribute("aria-invalid"); setHint(f, ""); });
        if (byKey.year) state.year = byKey.year.input.value.trim();
        var missing = !state.make ? byKey.make : (!state.model ? byKey.model : null);
        if (missing) {
          missing.input.setAttribute("aria-invalid", "true"); setHint(missing, T("fill_this_in", "Please fill this in – free text is allowed."), true);
          missing.input.focus(); toast(T("enter_make_model", "Please enter at least make and model.")); return;
        }
        var gen = state.gen || pickByYear(state.model, state.year);
        var label = state.make.name + " " + state.model.name + (gen ? " " + gen.code : "") + (state.year ? " · " + state.year : "");
        var vehicle = { make: state.make.name, model: state.model.name, generation: gen ? gen.name : "", code: gen ? gen.code : "",
                        handle: gen ? gen.handle : "", label: state.make.name + " " + state.model.name + (gen ? " " + gen.code : ""), year: state.year,
                        url: gen ? (ROOT + "/pages/vehicles/" + gen.handle) : "" };
        setVehicle(vehicle);
        if (form.getAttribute("data-finder") === "navigate" && gen) { window.location.href = vehicle.url; return; }

        if (resultTitle) resultTitle.textContent = label;
        if (resultSpecs) {
          resultSpecs.innerHTML = "";
          [[T("make", "Make"), state.make.name], [T("model", "Model"), state.model.name], [T("generation", "Generation"), gen ? gen.name : T("not_listed", "not listed")], [T("year", "Year"), state.year]].forEach(function (pair) {
            if (!pair[1]) return; var s = document.createElement("span"); s.textContent = pair[0] + ": " + pair[1]; resultSpecs.appendChild(s);
          });
        }
        if (body) body.hidden = true;
        if (result) { result.hidden = false; if (resultTitle) resultTitle.focus(); }
        if (!resultProducts) return;
        resultProducts.innerHTML = '<p class="ak-find-note">' + T("loading_parts", "Loading parts …") + '</p>';
        if (gen) {
          fetch(vehicle.url + "?section_id=hlc-generation-results", { credentials: "same-origin" })
            .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, "text/html");
              var inner = doc.querySelector("[data-results]");
              resultProducts.innerHTML = inner ? inner.innerHTML : html;
              resultProducts.insertAdjacentHTML("beforeend", '<p class="ak-result__actions"><a class="ak-btn" href="' + esc(vehicle.url) + '">All parts for this car <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h14M13 6l6 6-6 6"/></svg></a></p>');
              if (live) live.textContent = label + " " + T("selected_parts_loaded", "selected. Parts loaded.");
            })
            .catch(function () { window.location.href = vehicle.url; });
        } else {
          resultProducts.innerHTML = requestHtml(vehicle.label) + madeToOrderHtml(vehicle.label);
          if (live) live.textContent = label + " " + T("selected_no_generation", "selected. No catalogue generation – made-to-order products shown.");
        }
      });
      var resetBtn = $("[data-finder-reset]", panel);
      if (resetBtn) resetBtn.addEventListener("click", function () {
        if (result) result.hidden = true; if (body) body.hidden = false;
        ORDER.forEach(function (k) { var f = byKey[k]; state[k] = k === "year" ? "" : null; f.input.value = ""; f.wrap.classList.remove("is-filled"); setHint(f, ""); });
        if (byKey.make) window.setTimeout(function () { byKey.make.input.focus(); }, 60);
      });
    });
  })();

  /* ---------- Hub pre-filter (brand / model pages) --------------------- */
  $$("[data-prefilter]").forEach(function (box) {
    var q = $("[data-prefilter-q]", box), series = $("[data-prefilter-series]", box), year = $("[data-prefilter-year]", box), count = $("[data-prefilter-count]", box);
    var target = $(box.getAttribute("data-prefilter"));
    if (!target) return;
    var items = $$("[data-tile]", target);
    function apply() {
      var qq = norm2(q ? q.value : ""), s = series ? series.value : "", y = year ? parseInt(year.value, 10) : 0;
      var n = 0;
      items.forEach(function (it) {
        var ok = true;
        if (qq && (it.getAttribute("data-search") || "").indexOf(qq) === -1) ok = false;
        if (s && it.getAttribute("data-series") !== s) ok = false;
        if (y) { var f = parseInt(it.getAttribute("data-from") || "0", 10), t = parseInt(it.getAttribute("data-to") || "9999", 10); if (f && (y < f || y > t)) ok = false; }
        it.hidden = !ok; if (ok) n++;
      });
      if (count) count.textContent = n + " of " + items.length;
    }
    function norm2(s) { return String(s || "").trim().toLowerCase(); }
    [q, series, year].forEach(function (el) { if (el) el.addEventListener("input", apply); });
    apply();
  });
})();
